// extracted by mini-css-extract-plugin
export default {"filtersList":"ChatsFilters_filtersList__aQZ3b"};